module.exports = __webpack_public_path__ + "img/badge_software_bronze.52c33303.png";